import { render, staticRenderFns } from "./SubmitFormStage.vue?vue&type=template&id=4dfa8769&"
import script from "./SubmitFormStage.vue?vue&type=script&lang=js&"
export * from "./SubmitFormStage.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFormStage.vue?vue&type=style&index=0&id=4dfa8769&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports